<template>
<v-layout 
    v-if="types != null"
    row wrap
>
    <v-flex 
        v-for="(item, index) in types"
        :key="'type_'+index"
        xs12 md6 lg6
    >
    <v-card
        width="100%"
        height="100%"
        class="d-flex flex-column"
    >
        <v-img
            height="300"
            :src="'/app/bulk-message-template-images/'+item.type+'.jpg'"
            style="max-height: 300px"
        />

        <v-card-title>{{item.type_details.text}}</v-card-title>
        <v-card-subtitle>{{item.type_details.subtitle}}</v-card-subtitle>
        <v-card-text>
            <ul>
                <li
                    v-for="(template, index) in item.sample_templates"
                    :key="'template_'+index"
                >
                    <a 
                        v-on:click="$emit('create-message',template)"
                        class="message-link"
                    >
                        {{template.label}}
                    </a>
                </li>
            </ul>
        </v-card-text>

        <v-spacer/>
        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="primary"
                text
                v-on:click="$emit('view-all',item)"
            >
                View All {{item.templates.length}} Templates...
            </v-btn>
        </v-card-actions>

    </v-card>
    </v-flex>
</v-layout>
</template>

<script>
export default {
    props: {
    },

    data() {
        return {
            types: []
        }
    },

    mounted () {
        this.$rc.rest({
            'spinner': false,
            'endpoint': 'LIST: /api/v1/bulk/templates/by-type-summaries',
        
            'params' : {
                'organization_id': this.$route.params.organization_id,
            },
        
            'on_success': (data) => {
                    this.types = data.types.map(
                        (item) => {
                            item.sample_templates = item.templates.sort(() => 0.5 - Math.random()).slice(0,3); 
                            return item;
                        }
                    );


                },
        
            'on_error': 'Unable to list by type summaries',
        });
    },

    methods: {
        
    },
}
</script>

<style lang="scss" scoped>
.message-link:hover
{
    text-decoration: underline;
}
</style>